import Vue from 'vue'
import VueRouter from 'vue-router'
import { getLocalStorage } from '@/utils/utils'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('../views/index.vue')
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      hiddenFoot: true,
      navBarOperation: false
    },
    component: () => import('../views/login/index.vue')
  },
  {
    path: '/userCenter/:name',
    name: 'userCenter',
    meta: {
      auth: true
    },
    component: () => import('../views/userCenter/index.vue')
  },
  {
    path: '/productDetail',
    name: 'productDetail',
    meta: {
      hiddenFoot: true,
      navBarOperation: true,
      auth: true
    },
    component: () => import('../views/productDetail/index.vue')
  },
  {
    path: '/productPay/:orderId',
    name: 'productPay',
    meta: {
      hiddenFoot: true,
      navBarOperation: true,
      auth: true
    },
    component: () => import('../views/productDetail/productPay.vue')
  },
  // {
  //   path: '/demo',
  //   name: 'demo',
  //   component: () => import('../views/demo/demo1.vue')
  // },
  {
    path: '/orderDetail/:id',
    // path: '/orderDetail',
    name: 'orderDetail',
    meta: {
      hiddenFoot: false,
      navBarOperation: true,
      auth: true
    },
    component: () => import('../views/orderDetail/index.vue')
  },
  {
    path: '/underReview',
    name: 'underReview',
    meta: {
      hiddenFoot: true,
      navBarOperation: false
    },
    component: () => import('../views/underReview/index.vue')
  }
]

const router = new VueRouter({
  routes
})

const VueRouterPush = VueRouter.prototype.push
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch((err) => err)
}
VueRouter.prototype.replace = function push (to) {
  return VueRouterReplace.call(this, to).catch((err) => err)
}

router.beforeEach((to, from, next) => {
  if (getLocalStorage('token')) {
    if (to.path === '/login') {
      next('/')
    } else {
      next()
    }
  } else if (to.meta.auth) {
    next('/login')
  } else {
    next()
  }
})

export default router
